
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DatabaseInterface } from '@/services/Database/interfaces';

@Component({
  mixins: [Themeable],
})
export default class SyncDatabaseSizeDialog extends Vue {
  @Prop() public readonly database!: DatabaseInterface;

  public visible: boolean = true;

  public destroyComponent(): void {
    this.$emit('close');
  }

  public async syncSize(): Promise<void> {
    this.$emit('syncSize', this.database);

    this.destroyComponent();
  }
}
